import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import BaseModal from './BaseModal';
import ScheduleModal from './ScheduleModal';

const ServiceModal = ({ isOpen, onClose, service }) => {
  const { t } = useTranslation();
  const [isScheduleModalOpen, setIsScheduleModalOpen] = useState(false);

  if (!isOpen || !service) return null;

  const handleGetQuote = () => {
    onClose(); // Close service modal
    setIsScheduleModalOpen(true); // Open schedule modal
  };

  return (
    <BaseModal 
      isOpen={isOpen} 
      onClose={onClose}
      maxWidth="max-w-3xl"
    >
      <div className="pt-8">
        {/* Service Icon & Title */}
        <div className="flex flex-col sm:flex-row items-start space-y-4 sm:space-y-0 sm:space-x-6 mb-6 pr-8">
          <div 
            className="w-16 h-16 sm:w-20 sm:h-20 rounded-2xl flex items-center justify-center flex-shrink-0"
            style={{ backgroundColor: `${service.color}20` }}
          >
            <service.icon className="text-3xl sm:text-4xl" style={{ color: service.color }} />
          </div>
          <div>
            <h2 className="text-2xl sm:text-3xl font-bold text-white mb-2">{t(service.titleKey)}</h2>
            <p className="text-white/70 text-base sm:text-lg">{t(service.descKey)}</p>
          </div>
        </div>

        {/* Service Image */}
        <div className="rounded-2xl overflow-hidden mb-6">
          <img
            src={service.image}
            alt={t(service.titleKey)}
            className="w-full h-48 sm:h-64 object-cover"
          />
        </div>

        {/* Detailed Features */}
        <div className="space-y-6">
          <div>
            <h3 className="text-lg sm:text-xl font-bold text-white mb-4">{t('serviceModal.features')}</h3>
            <div className="grid sm:grid-cols-2 gap-3 sm:gap-4">
              {service.featuresKeys.map((featureKey, idx) => (
                <div key={idx} className="flex items-start space-x-3 glass rounded-xl p-3 sm:p-4">
                  <div 
                    className="w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0 mt-1"
                    style={{ backgroundColor: `${service.color}40` }}
                  >
                    <div className="w-2 h-2 rounded-full" style={{ backgroundColor: service.color }} />
                  </div>
                  <span className="text-white/80 text-sm sm:text-base">{t(featureKey)}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Benefits */}
          <div>
            <h3 className="text-lg sm:text-xl font-bold text-white mb-4">{t('serviceModal.benefits')}</h3>
            <div className="glass rounded-2xl p-4 sm:p-6">
              <ul className="space-y-3 text-white/70 text-sm sm:text-base">
                <li className="flex items-start space-x-3">
                  <span className="text-[#00d4ff] text-xl">✓</span>
                  <span>{t('serviceModal.benefit1')}</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="text-[#00d4ff] text-xl">✓</span>
                  <span>{t('serviceModal.benefit2')}</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="text-[#00d4ff] text-xl">✓</span>
                  <span>{t('serviceModal.benefit3')}</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="text-[#00d4ff] text-xl">✓</span>
                  <span>{t('serviceModal.benefit4')}</span>
                </li>
              </ul>
            </div>
          </div>

          {/* CTA */}
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
            <button 
              onClick={handleGetQuote}
              className="flex-1 btn-primary"
            >
              {t('serviceModal.getQuote')}
            </button>
            <button 
              onClick={onClose}
              className="flex-1 btn-secondary"
            >
              {t('serviceModal.close')}
            </button>
          </div>
        </div>
      </div>

      {/* Schedule Modal */}
      <ScheduleModal
        isOpen={isScheduleModalOpen}
        onClose={() => setIsScheduleModalOpen(false)}
      />
    </BaseModal>
  );
};

export default ServiceModal;
